import { i18n } from '@/locales';
const { t } = i18n;
export default {
    // 임의상품
    TEMP_GOODS: {
        text: t('views.order_detail.order_detail_adjust_payment.temp_goods_for_adjust_payment'),
        tempMajor: '888',
    },
    // 배달팁
    DELIVERY_FEE: {
        text: t('views.order_detail.order_detail_adjust_payment.delivery_fee'),
        tempMajor: '999',
    },
};
